import { getAuthInformation } from "@dafiti/authentication-sdk";
import { getCookie } from "cookies-next/client";

export function getCatalogHeaders(): Record<string, string> {
  const { isLoggedIn, customerId } = getAuthInformation();
  const raw = getCookie("feature_flag_uuid") || "";

  return {
    "X-Device-Id": raw,
    ...(isLoggedIn && customerId ? { "X-Customer-Id": customerId } : {}),
  };
}
